export const setValue = (
  obj: any,
  paths: string[],
  value: string | number | boolean,
  deviceType: string,
): any => {
  if (!obj) return
  let [key] = paths;
  key = key.replace(/\$deviceType/g, deviceType)

  if (paths.length === 1) {
    obj[key] = value;
    return;
  }
  if (!obj?.hasOwnProperty(key)) {
    obj[key] = {};
  }
  return setValue(obj[key], paths.slice(1), value, deviceType);
};

export const getValue = (
  obj: any,
  paths: string[],
  deviceType: string,
): any => {
  if (!obj) return
  let [key] = paths;
  key = key.replace(/\$deviceType/g, deviceType)

  if (paths.length === 1) {
    return obj[key]
  }

  if (!obj.hasOwnProperty(key)) {
    obj[key] = {};
  }

  return getValue(obj[key], paths.slice(1), deviceType);
};
